import { Tab, Tabs, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../../../components/Accessibility/VoltarButton';
import LoadingApp from '../../../../../components/LoadingApp';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import TermosUsoModal from '../../components/TermosUsoModal';
import TranscricaoDadosPedidoTab from './TranscricaoDadosPedidoTab';
import TranscricaoHistoricoTimeline from './TranscricaoHistoricoTimeline';
import TranscricaoResumoCard from './TranscricaoResumoCard';
import { useDetalhesTranscricaoPage } from './hooks/useDetalhesTranscricaoPage';
import { sxTranscricaoDetalheTab, sxTranscricaoDetalheTabs } from './sxProps';
import './styles.css';

const DetalhesTranscricao: React.FC = () => {
  const navigate = useNavigate();
  const accessibility = useAccessibility();
  const {
    idTranscricao,
    loading,
    erro,
    detalhe,
    codStatusCliente,
    abaAtiva,
    setAbaAtiva,
    termosModalAberto,
    setTermosModalAberto,
    timelineSteps,
    erroHistoricoSumario,
    handleResolverPendencia,
    voltarPath,
  } = useDetalhesTranscricaoPage();

  return (
    <div className="transcricao-detalhe-container">
      <LoadingApp showLoading={loading} />

      {!loading && (
        <>
          <PageTitle
            text="Detalhes da transcrição"
            className="transcricao-detalhe-title"
            id="detalhes-transcricao-title"
          />

          {erro && (
            <Typography style={accessibility.textStyleAccessibility} className="transcricao-detalhe-erro">
              {erro}
            </Typography>
          )}

          {!erro && detalhe && idTranscricao && (
            <>
              <TranscricaoResumoCard
                detalhe={detalhe}
                codStatusTranscricao={codStatusCliente ?? detalhe.codStatusTranscricao}
                onVisualizarTermo={() => setTermosModalAberto(true)}
              />

              <Tabs
                value={abaAtiva}
                onChange={(_event, value) => setAbaAtiva(value)}
                sx={sxTranscricaoDetalheTabs}
                aria-label="Abas dos detalhes da transcrição"
              >
                <Tab
                  value="historico"
                  label="Histórico da solicitação"
                  sx={sxTranscricaoDetalheTab}
                />
                <Tab value="dados" label="Dados do pedido" sx={sxTranscricaoDetalheTab} />
              </Tabs>

              <div className="transcricao-detalhe-tabs-content">
                {abaAtiva === 'historico' && (
                  <TranscricaoHistoricoTimeline
                    steps={timelineSteps}
                    erro={erroHistoricoSumario}
                    onResolver={handleResolverPendencia}
                  />
                )}

                {abaAtiva === 'dados' && (
                  <TranscricaoDadosPedidoTab idTranscricao={idTranscricao} detalhe={detalhe} />
                )}
              </div>
            </>
          )}

          <div className="transcricao-detalhe-actions">
            <VoltarButton onClick={() => navigate(voltarPath)} />
          </div>

          <TermosUsoModal
            open={termosModalAberto}
            onClose={() => setTermosModalAberto(false)}
            variant="view"
          />
        </>
      )}
    </div>
  );
};

export default DetalhesTranscricao;
